import { render, staticRenderFns } from "./AdminCompanyView.vue?vue&type=template&id=3266e28a&"
import script from "./AdminCompanyView.vue?vue&type=script&lang=js&"
export * from "./AdminCompanyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports